module.exports = __webpack_public_path__ + "static/media/nt_logomark_blue.62fb9cd0.svg";